var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"top"},[_c('Header'),_c('v-main',{staticClass:"main"},[_c('v-container',{staticClass:"content",attrs:{"id":_vm.containerId}},[_c('router-view',{key:_vm.key})],1)],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }